import React from 'react';

const UserStatusBadge = ({ status, className = '' }) => {
    const statusConfig = {
        'active': {
            text: '啟用',
            className: 'bg-green-100 text-green-800'
        },
        'inactive': {
            text: '停用',
            className: 'bg-red-100 text-red-800'
        },
        'pending': {
            text: '待審核',
            className: 'bg-yellow-100 text-yellow-800'
        },
        'suspended': {
            text: '暫停',
            className: 'bg-gray-100 text-gray-800'
        }
    };

    const { text, className: statusClassName } = statusConfig[status] || {
        text: '未知狀態',
        className: 'bg-gray-100 text-gray-800'
    };

    return (
        <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${statusClassName} ${className}`}
        >
            {text}
        </span>
    );
};

export default UserStatusBadge;